<template>
  <div>
    <div class="container">
      <div class="slider to-index">
        <div class="slide" v-for="(item, index) in videoData" :key="item.id">
          <video
            muted
            autoplay
            loop
            playsinline
            poster="https://img.davich.com/mobile/image/main/img-main-page.png"
            :class="{ active: index === count }"
            @timeupdate="handleProgress(index, $event)"
          >
            <source :src="item.mobileUrl" type="video/mp4" />
            <strong>Your browser does not support the video tag.</strong>
          </video>
          <div class="slide-desc">
            <h2 class="en-font">
              {{ item.title }}
            </h2>
            <p>
              {{ item.subtitle }}
            </p>
          </div>
        </div>

        <div class="arrow-wrap">
          <button class="arrow-left" @click="showPreviousItem()">
            <img src="https://img.davich.com/mobile/image/main/btn-caret-left.png" alt="" />
          </button>
          <button class="arrow-right" @click="showNextItem()">
            <img src="https://img.davich.com/mobile/image/main/btn-caret-right.png" alt="" />
          </button>
        </div>
        <div class="video-control">
          <div class="progress-wrap en-font">
            <!-- 영상 개수만큼만 생성 -->
            <div class="progress-bar" v-for="(item, index) in videoData" :key="item.id">
              <p>{{ String(index + 1).padStart(2, "0") }}</p>
              <div class="progress" :style="{ display: index === count ? 'flex' : 'none' }">
                <div class="progress__filled" :style="{ flexBasis: `${percent}%` }"></div>
              </div>
            </div>
          </div>
          <div class="slider-ctrl-btn-box">
            <button class="slider-ctrl-btn__play sm" :class="{ on: paused }" @click="playVideo()">
              <img src="https://img.davich.com/image/main/btn-play.png" alt="play button" />
            </button>
            <button class="slider-ctrl-btn__pause sm" :class="{ on: !paused }" @click="pauseVideo()">
              <img src="https://img.davich.com/image/main/btn-stop.png" alt="play button" />
            </button>
          </div>
        </div>
        <button class="scroll-arrow" @click="scrollDown()">
          <img src="https://img.davich.com/mobile/image/main/icon-scroll-arrow.png" alt="" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  beforeCreate() {
    this.$store.dispatch("FETCH_MAIN_VIDEO");
  },

  data() {
    return {
      count: 0,
      percent: 0,
      paused: false,
    };
  },

  computed: {
    ...mapState({
      videoData: (state) => state.videoData,
    }),
  },

  watch: {
    //영상 데이터가 들어오면 실제 개수 범위 안에서 랜덤 시작
    videoData: {
      immediate: true,
      handler(list) {
        this.count = list.length ? Math.floor(Math.random() * list.length) : 0;
        this.percent = 0;
      },
    },
  },

  methods: {
    handleProgress(index, event) {
      if (index !== this.count) return;
      const video = event.target;
      this.percent = video.duration ? (video.currentTime / video.duration) * 100 : 0;
    },

    showNextItem() {
      const itemCount = this.videoData.length;
      if (!itemCount) return;
      this.selectVideo((this.count + 1) % itemCount);
    },

    showPreviousItem() {
      const itemCount = this.videoData.length;
      if (!itemCount) return;
      this.selectVideo((this.count - 1 + itemCount) % itemCount);
    },

    selectVideo(index) {
      this.count = index;
      this.percent = 0;
      //이전 영상에서 일시정지했더라도 새로 보이는 영상은 재생
      this.$nextTick(() => {
        const video = this.activeVideo();
        if (video && video.paused) video.play().catch(() => {});
        this.paused = false;
      });
    },

    activeVideo() {
      return this.$el.querySelectorAll("video")[this.count];
    },

    pauseVideo() {
      const video = this.activeVideo();
      if (!video) return;
      video.pause();
      this.paused = true;
    },
    playVideo() {
      const video = this.activeVideo();
      if (!video) return;
      video.play();
      this.paused = false;
    },
    scrollDown() {
      let brandContent = document.querySelector(".count-year");
      let scrollContent = window.pageYOffset + brandContent.getBoundingClientRect().top - 64.5;
      window.scrollTo({
        top: scrollContent,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";
.container {
  background-color: black;
  position: relative;
  width: 100vw;
  height: 177.77vw;
  overflow: hidden;
  .slider {
    width: 100%;
    height: 100%;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: $color-black;
      opacity: 0.05;
      z-index: 2;
    }
    .slide {
      width: 100%;
      height: 100%;
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        display: none;
        &.active {
          display: block;
          animation: fadeImg 0.8s;
        }
      }
      video.active + .slide-desc {
        display: block;
      }
      .slide-desc {
        width: 85vw;
        display: none;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 99;
        text-align: center;
        color: $color-white;
        h2 {
          font-size: 40px;
          letter-spacing: -1.2px;
          font-weight: bold;
          margin-bottom: 10px;
          img {
            height: 40px;
          }
        }
        p {
          font-size: 17px;
          opacity: 0.8;
          letter-spacing: -0.51px;
          font-weight: 300;
          line-height: normal;
        }
      }
    }
    .arrow-wrap {
      @include box-center;
      width: 100vw;
      z-index: 999;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .arrow-left,
      .arrow-right {
        width: 15vw;
        height: 15vw;
        img {
          height: 7.4vw;
        }
      }
    }
    .scroll-arrow {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
      border: 1px solid $color-white;
      img {
        @include box-center;
        width: 22px;
        height: 22px;
      }
    }
  }
}

.video-control {
  display: none;
}

//화면전환 시 효과
@keyframes fadeImg {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
